__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@mindtickle/dsr-client";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "4.33.0", function() { return __webpack_require__.e(7380).then(function() { return function() { return __webpack_require__(17380); }; }); });
			register("@mui/material", "5.18.0", function() { return Promise.all([__webpack_require__.e(1773), __webpack_require__.e(3217), __webpack_require__.e(8739), __webpack_require__.e(1502), __webpack_require__.e(2324), __webpack_require__.e(6491), __webpack_require__.e(6016)]).then(function() { return function() { return __webpack_require__(88739); }; }); });
			register("@mui/private-theming", "5.17.1", function() { return Promise.all([__webpack_require__.e(1502), __webpack_require__.e(3198)]).then(function() { return function() { return __webpack_require__(73198); }; }); });
			register("@mui/styles", "5.18.0", function() { return Promise.all([__webpack_require__.e(9593), __webpack_require__.e(1502), __webpack_require__.e(7556)]).then(function() { return function() { return __webpack_require__(19469); }; }); });
			register("antd", "4.10.3", function() { return Promise.all([__webpack_require__.e(483), __webpack_require__.e(2388), __webpack_require__.e(6744), __webpack_require__.e(1500), __webpack_require__.e(1502), __webpack_require__.e(2324), __webpack_require__.e(7547)]).then(function() { return function() { return __webpack_require__(91500); }; }); });
			register("lodash", "4.17.21", function() { return __webpack_require__.e(2043).then(function() { return function() { return __webpack_require__(32043); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(2469), __webpack_require__.e(1502)]).then(function() { return function() { return __webpack_require__(42469); }; }); });
			register("react-intl", "2.9.0", function() { return Promise.all([__webpack_require__.e(4243), __webpack_require__.e(1502), __webpack_require__.e(3486)]).then(function() { return function() { return __webpack_require__(34243); }; }); });
			register("react-router-dom", "6.0.0-beta.0", function() { return Promise.all([__webpack_require__.e(1159), __webpack_require__.e(1502), __webpack_require__.e(3654)]).then(function() { return function() { return __webpack_require__(5267); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(3216).then(function() { return function() { return __webpack_require__(33216); }; }); });
			register("styled-components", "5.3.0", function() { return Promise.all([__webpack_require__.e(6973), __webpack_require__.e(1502), __webpack_require__.e(6467)]).then(function() { return function() { return __webpack_require__(76973); }; }); });
			initExternal(92339);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};